import { render } from "./ClientCreateForm.vue?vue&type=template&id=6fa828a5&scoped=true"
import script from "./ClientCreateForm.vue?vue&type=script&lang=js"
export * from "./ClientCreateForm.vue?vue&type=script&lang=js"

import "./ClientCreateForm.vue?vue&type=style&index=0&id=6fa828a5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa828a5"]])

export default __exports__